// extracted by mini-css-extract-plugin
export default {"content":"styles_content__qa46h","spinner":"styles_spinner__nkaya","spin":"styles_spin__Tyqxx","text-style":"styles_text-style__3CYY6"};